import React, { Component } from 'react'

export default class FirstComp extends Component {
  constructor(){
    super();
    this.state = {
      name:'jayesh',
      count: 0
    }
  }

  updteName(){
    this.setState({
      name:'Deepti',
      count: this.state.count + 1
    })
  }
  deupdteName(){
    this.setState({
      count: this.state.count - 1
    })
  }
  render() {
    return (
      <div>
        <h1>This is First Component of {this.state.count}</h1>
        <button onClick={()=>{this.updteName()}}>Update</button>
        <button onClick={()=>{this.deupdteName()}}>DeUpdate</button>
      </div>
    )
  }
}

